import { useCallback } from "react";
import { useSearchClient } from "../../common/api/queries";
import { useClientSearchActions, useClientSearchResult, useIsClientSearchInProgress } from "./store";
import type { ClientSearchRequest, ClientSearchResult } from "./types";

export interface ClientSearchProps {
  result: ClientSearchResult;
  inProgress: boolean;
  onSearch: (request: ClientSearchRequest) => void;
  onResultDelete: () => void;
}

export const useClientSearch = (): ClientSearchProps => {
  const result = useClientSearchResult();
  const inProgress = useIsClientSearchInProgress();
  const actions = useClientSearchActions();
  const searchClient = useSearchClient();

  const onSearch = useCallback(
    (request: ClientSearchRequest) => {
      const searchId = actions.searchStarted();

      // The promise, unlike mutate() callbacks, settles after an unmount too, so the result still reaches the store.
      // Both handlers in one then(), so a failing success handler cannot settle the same search twice.
      searchClient.mutateAsync(request).then(
        (data) => actions.searchSucceeded(searchId, data),
        () => actions.searchFailed(searchId),
      );
    },
    [actions, searchClient.mutateAsync],
  );

  return { result, inProgress, onSearch, onResultDelete: actions.resultDeleted };
};
